module.exports = __webpack_public_path__ + "img/icon_golden_followers.6286fced.png";